import { defineComponent as _defineComponent } from 'vue'
import useFormattingPhoneNumber from "@/use/useFormattingPhoneNumber";
import { computed } from "vue";

const maskingPasswordLength = 8;

export default /*#__PURE__*/_defineComponent({
  __name: 'MyInfoRow',
  props: {
  keyValue: {
    type: String,
  },
  label: {
    type: String,
  },
  value: {
    type: String,
  },
},
  emits: ["onClickRow"],
  setup(__props, { expose: __expose }) {
  __expose();

const props = __props;



const formattedPhoneNumber = computed(() =>
  useFormattingPhoneNumber(props.value ?? "")
);

const __returned__ = { props, maskingPasswordLength, formattedPhoneNumber }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})